import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useUnleashContext } from '@unleash/proxy-client-react';

/**
 * Sincroniza userId (e-mail) no Unleash antes dos useFlag nos filhos.
 * Sem isso, flags com estratégia por usuário ficam false no primeiro render.
 */
const UnleashUserContext = () => {
  const user = useSelector(state => state.authentication?.user);
  const updateContext = useUnleashContext();

  useEffect(() => {
    const email = user?.email;
    if (!email || !user?.isLoggedIn?.()) {
      return;
    }

    updateContext({ userId: email });
  }, [user, updateContext]);

  return null;
};

export default UnleashUserContext;
